export const actions = {
  namespaced: true,
  state: {
    lastDispatchAction: null,
  },
  mutations: {
    last_dispatched_action: (state, actionObject) => {
      state.lastDispatchAction = actionObject;
    },
  },
};
